import { BaseModel } from "model/BaseModel";
import Coleta from "../coleta/Coleta";
import MdfeCte from "../mdfe/MdfeCte";
import Rota from "./Rota";
import { BaseEditModel } from "model/BaseEditModel";
import Endereco from "../endereco/Endereco";
import ItemRotaImagem from "./ItemRotaImagem";
import ItemRotaPontoPercurso from "./ItemRotaPontoPercurso";

export default class ItemRota implements BaseEditModel {

    id: number;
    codigo = "";
    key = "";
    sequencial: number;
    tipo: string;
    status: string;
    resultado: string;
    dataPrevista: Date | null;
    dataRealizada: Date | null;
    observacao: string;
    observacaoMotorista: string;
    nomeRecebedor: string;
    documentoRecebedor: string;
    telefoneRecebedor: string;
    assinaturaRecebedor: string | null;
    canhoto: string | null;
    rota: Rota | null;
    coleta: Coleta | null;
    mdfeCte: MdfeCte | null;
    endereco: Endereco | null;
    imagens: ItemRotaImagem[] = [];
    pontosPercurso: ItemRotaPontoPercurso[] = [];

    constructor(
        id: number = 0,
        sequencial: number = 0,
        tipo: string = "",
        status: string = "CRIADO",
        resultado: string = "",
        dataPrevista: Date | null = null,
        dataRealizada: Date | null = null,
        observacao: string = "",
        observacaoMotorista: string = "",
        nomeRecebedor: string = "",
        documentoRecebedor: string = "",
        telefoneRecebedor: string = "",
        assinaturaRecebedor: string | null = null,
        canhoto: string | null = null,
        rota: Rota | null = null,
        coleta: Coleta | null = null,
        mdfeCte: MdfeCte | null = null,
        endereco: Endereco | null = null
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.tipo = tipo;
        this.status = status;
        this.resultado = resultado;
        this.dataPrevista = dataPrevista;
        this.dataRealizada = dataRealizada;
        this.observacao = observacao;
        this.observacaoMotorista = observacaoMotorista;
        this.nomeRecebedor = nomeRecebedor;
        this.documentoRecebedor = documentoRecebedor;
        this.telefoneRecebedor = telefoneRecebedor;
        this.assinaturaRecebedor = assinaturaRecebedor;
        this.canhoto = canhoto;
        this.rota = rota;
        this.coleta = coleta;
        this.mdfeCte = mdfeCte;
        this.endereco = endereco;
    }
}